import { businessInfo } from "./content";

export function getHomeJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": ["Plumber", "LocalBusiness"],
    name: businessInfo.name,
    description: "Artisan plombier chauffagiste à Meaux (77). Dépannage, installation, entretien, rénovation. Intervention rapide. Devis gratuit.",
    url: `https://${businessInfo.domain}`,
    telephone: businessInfo.phone,
    email: businessInfo.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: businessInfo.address.street,
      addressLocality: businessInfo.address.city,
      postalCode: businessInfo.address.zip,
      addressCountry: "FR",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "[LATITUDE]",
      longitude: "[LONGITUDE]",
    },
    image: "[LOGO_FINAL]",
    priceRange: "$$",
    openingHoursSpecification: "[HORAIRES]",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: businessInfo.googleReviewRating,
      reviewCount: businessInfo.googleReviewCount,
      bestRating: 5,
    },
    areaServed: [
      { "@type": "City", name: "Meaux" },
      { "@type": "City", name: "Esbly" },
      { "@type": "City", name: "Trilport" },
      { "@type": "City", name: "Crégy-les-Meaux" },
      { "@type": "City", name: "Quincy-Voisins" },
    ],
    sameAs: [],
  };
}

export function getFaqJsonLd(faqItems) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export function getBreadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url ? `https://${businessInfo.domain}${item.url}` : undefined,
    })),
  };
}
